import { TableType } from '@soposopo/sopo-models';
import { GameStateId } from '../game/game.state';

export interface GameSocketState {
    sockets: Socket[];
    latestEvent?: any;
    latestPayload?: any;
    inputConfirmed: boolean;
    messageFromDealer?: string;
    messageFromTableHost?: string;
    error?: any;
}

export const GAME_SOCKET_INIT_STATE: GameSocketState = {
    sockets: [],
    inputConfirmed: false,
};

export interface Socket {
    connectionStatus: SocketConnectionStatus;
    url: string;
    gameStateId: GameStateId;
    gameServerId: string;
    gameType: TableType;
    socketId: string;
}

export type SocketConnectionStatus = 'connecting' | 'connected' | 'disconnected';
